import React, { Fragment } from "react";
import FormControl from "@mui/material/FormControl";
import { InputLabel, MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import { notBlank } from "../../../util/ext";
import { useAudioTypes } from "../../vocabularyServices";
import { Skeleton } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";

const AudioTypeSelect = props => {
  const {
    onBlur,
    onChange,
    value,
    required = false,
    error = false,
    helperText = "",
    valueFormat = "name",
  } = props;
  const audioTypes = useAudioTypes();

  return (
    <Fragment>
      {audioTypes.isLoading ? (
        <Skeleton variant="text" />
      ) : (
        <FormControl fullWidth required={required} error={error}>
          <InputLabel htmlFor="content-audioType">Audio Type</InputLabel>
          <Select
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            inputProps={{
              name: "content-audioType",
              id: "content-audioType",
            }}
          >
            {audioTypes.data.map(at => {
              return (
                <MenuItem
                  value={valueFormat === "name" ? at.name : at}
                  key={at.name}
                >
                  {at.display}
                </MenuItem>
              );
            })}
          </Select>
          {notBlank(error) && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
      )}
    </Fragment>
  );
};

export default AudioTypeSelect;
